import { useState } from 'react';

export type ModalContext = {
  show: boolean;
  open: () => void;
  close: () => void;
  onAction: () => void;
};

export const useModal = (onAction: () => void): ModalContext => {
  const [showModal, setShowModal] = useState(false);

  const openModal = (): void => {
    setShowModal(true);
  };

  const closeModal = (): void => {
    setShowModal(false);
  };

  return { show: showModal, close: closeModal, open: openModal, onAction };
};
